<!--
 * @Author: Ashley.Liu
 * @Date: 2022-02-23 14:48:40
 * @LastEditTime: 2022-05-17 16:56:58
 * @Description: copy for cell
-->
<template>
  <div class="async-copy-component">
    <div
      v-if="content"
      :class="[ type === 'hover' ? 'copy' : '', `offset-${offset}`]"
      @click="copy"
    >
      <button
        class="zm-button zm-button--icon"
        type="button"
        :ref="'copy_' + this.uuid"
        :id="'copy_' + this.uuid"
        @click="copy"
        data-clipboard-action="copy"
      >
        <i class="zm-icon-copy"></i>
      </button>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import { uuid } from '@/utils'

export default {
  name: 'Copy',
  props: {
    content: {
      type: [String, Object, Array],
      default: ''
    },
    type: {
      type: String,
      default: 'hover'
    },
    offset: {
      type: Number,
      default: 4
    }
  },
  data () {
    return {
      uuid
    }
  },
  created () {
    this.uuid = uuid()
  },
  methods: {
    copy () {
      let payload = this.content
      if (typeof this.content !== 'string') {
        payload = JSON.stringify(this.content)
      }
      const clipboard = new Clipboard('#copy_' + this.uuid, {
        text: () => {
          return payload
        }
      })
      clipboard.on('success', () => {
        if (!this.timer) {
          this.timer = setTimeout(() => {
            clearTimeout(this.timer)
            this.$message.success('Copied to clipboard')
          }, 100)
        }
        clipboard.destroy()
      })
      clipboard.on('error', clipboard.destroy)
    }
  }
}
</script>

<style lang="scss">
.async-copy-component {
  width: 100%;
  height: 100%;
  .copy {
    display: none;
    width: 20px;
    height: 20px;
    display: none;
  }
  &:hover .copy {
    display: inherit;
  }
  $offset: -2, 0, 2, 4, 8, 16, 20, 24;
  @each $o in $offset {
    .copy.offset-#{$o} {
      position: absolute;
      top: 0;
      left: -#{$o}px;
    }
  }
  .zm-button--icon,
  .zm-button--icon:hover,
  .zm-button--icon:focus {
    border: none;
  }
  .zm-icon-copy {
    font-size: 12px;
  }
}
</style>
